
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AppService } from 'src/app/app.service';
import { WelcomeComponent } from '../../shared/pages/0-welcome/welcome.component';
import { ProjectOverviewComponent } from '../../shared/pages/1-project-overview/project-overview.component';
import { EnvironmentalComponent } from 'src/app/shared/pages/2-environmental/environmental.component';
import { AlternativesComponent } from 'src/app/shared/pages/4-alternatives/alternatives.component';
import { TrafficComponent } from 'src/app/shared/pages/3-traffic/traffic.component';
import { PublicCommentComponent } from 'src/app/shared/pages/5-public-comment/public-comment.component';

@Component({
  selector: 'app-main-content',
  templateUrl: './main-content.component.html',
  styleUrls: ['./main-content.component.scss'],
  imports: [
    MatIconModule,
    WelcomeComponent,
    ProjectOverviewComponent,
    EnvironmentalComponent,
    TrafficComponent,
    AlternativesComponent,
    PublicCommentComponent
],
})
export class MainContentComponent implements OnInit {
  pageIndex = 0;
  pages: string[] = [];
  isTransitioning = false;

  @ViewChild('contentDiv') contentDiv!: ElementRef;

  constructor(private appService: AppService) {
    this.pages = this.appService.pages;
  }

  ngOnInit(): void {
    this.appService.getPageIndex().subscribe({
      next: (pageIndex: number) => {
        this.pageIndex = pageIndex;
        this.appService.emitScrollToTop();
      },
      error: (error) => {
        console.error('Error getting pageIndex:', error);
      },
    });
  }

  setPageIndex(index: number) {
    this.pageIndex = index;
    this.appService.setPageIndex(index);
  }
}
